import { FormGroup } from "../../../../components/common";
import { Control } from "react-redux-form";
import Select from "react-select";
import React from "react";
import { useTrackingCategories } from "./useTrackingCategories";
import { useTranslation } from "react-i18next";
import { Col } from "reactstrap";

export const TrackingCategories = () => {
  const { data: trackingCategories } = useTrackingCategories();
  const { t } = useTranslation();

  return (
    <>
      {trackingCategories.map((i, idx) => (
        <Col lg="auto" key={i.TrackingCategoryID}>
          <FormGroup
            translate={false}
            label={t("Filter by {{ Name }}", i)}
            addControlClass={false}
          >
            <Control.select
              component={Select}
              style={{ minWidth: "10rem" }}
              options={i.Options}
              labelKey="Name"
              simpleValue
              valueKey="TrackingOptionID"
              model={`.trackingOptionID${idx + 1}`}
              placeholder={t('Select...')}
            />
          </FormGroup>
        </Col>
      ))}
    </>
  );
};
